import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  isOpen: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  isOpen: false,
  className: '',
};

const Burger = ({ isOpen, onClick, className, ...other }) => {
  const burgerClassName = classNames(className, 'Burger', {
    'Burger--active': isOpen,
  });

  return (
    <button
      className={burgerClassName}
      onClick={onClick}
      {...other}
      aria-label="menu"
    >
      <span className="Burger__bar" />
      <span className="Burger__bar" />
      <span className="Burger__bar" />
    </button>
  );
};

Burger.defaultProps = defaultProps;
Burger.propTypes = propTypes;

export default Burger;
